import {
  formatListingDate,
  formatListingDateTime,
  formatListingTime,
} from "../../../utils/formatListingDate";

export const formatDate = formatListingDate;
export const formatDateTime = formatListingDateTime;
export const formatTime = formatListingTime;

export const getPaymentStatus = (booking) => {
  if (parseFloat(booking?.balance) === 0) {
    return "Paid";
  }
  if (parseFloat(booking?.total_paid) > 0) {
    return "Partially Paid";
  }
  return "Unpaid";
};

export const getPaymentStatusColor = (status) => {
  switch (status) {
    case "Paid":
      return "bg-emerald-50 text-emerald-700 ring-emerald-600/20";
    case "Partially Paid":
      return "bg-amber-50 text-amber-700 ring-amber-600/20";
    case "Unpaid":
      return "bg-red-50 text-red-700 ring-red-600/20";
    default:
      return "bg-gray-50 text-gray-700 ring-gray-500/10";
  }
};

export const getDaysUntilTravel = (dateString) => {
  if (!dateString) return null;
  const travel = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  travel.setHours(0, 0, 0, 0);
  const diff = Math.ceil((travel - today) / (1000 * 60 * 60 * 24));
  if (diff < 0) return "Travel date passed";
  if (diff === 0) return "Travels today";
  if (diff === 1) return "Travels tomorrow";
  return `In ${diff} days`;
};

export const viewDetailsButtonClass =
  "inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-medium text-primary transition hover:bg-primary/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/30";

export const selectedRowClass = (isSelected) =>
  isSelected ? "bg-primary/5 ring-1 ring-inset ring-primary/20" : "";
